import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import { fetchServicePage } from '../services/servicePages';
import './ServiceDetails.css';

const ServiceDetails = () => {
  const { slug } = useParams();
  const [servicePage, setServicePage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadServicePage = async () => {
      try {
        setLoading(true);
        setError('');
        const data = await fetchServicePage(slug);
        if (!cancelled) setServicePage(data);
      } catch (err) {
        if (!cancelled) {
          setServicePage(null);
          setError(
            err.response?.status === 404
              ? 'This service page is not available yet.'
              : err.response?.data?.message || 'Failed to load this service.'
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadServicePage();
    return () => { cancelled = true; };
  }, [slug]);

  const title = servicePage?.title || 'Service Details';

  return (
    <Layout>
      <PageMeta
        title={title}
        description={servicePage?.summary || 'View service options and details from FM Ultratech Farms.'}
      />
      <div className="service-details-page">
        <section className="service-details-hero">
          <div className="service-details-container">
            <Link to="/services" className="service-back-link">&larr; All Services</Link>
            <h1>{title}</h1>
            {servicePage?.summary && <p>{servicePage.summary}</p>}
          </div>
        </section>

        <section className="service-variations-section">
          <div className="service-details-container">
            {loading ? (
              <div className="service-details-status">Loading service details...</div>
            ) : error ? (
              <div className="service-details-status service-details-status--error">
                <p>{error}</p>
                <Link to="/services">Return to Services</Link>
              </div>
            ) : !servicePage?.variations?.length ? (
              <div className="service-details-status">
                Detailed options and quotations will be added soon. Please contact us for assistance.
              </div>
            ) : (
              <div className="service-variations-list">
                {servicePage.variations.map((variation, index) => (
                  <article className="service-variation" key={variation.id}>
                    <div className="service-variation-number">{String(index + 1).padStart(2, '0')}</div>
                    <div className="service-variation-body">
                      <h2>{variation.title}</h2>
                      <div
                        className="service-rich-content"
                        dangerouslySetInnerHTML={{ __html: variation.content }}
                      />
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default ServiceDetails;
